import { useRef } from 'react';
import { NewsCardModal } from '../../../../../components/Module/News/Components/NewsCard';
import { useMapWidgetStore } from '../MapWidgetContext';
import { NewsActivator, NewsActivatorProps } from './Activator';
import { NewsContext } from './context';
import { MapWidgetNewsStore } from './store';

interface NewsInitializerProps extends Pick<NewsActivatorProps, 'status'> {
  children?: React.ReactNode;
}

export const NewsInitializer = ({ children, status }: NewsInitializerProps) => {
  const { map, mouseController } = useMapWidgetStore();

  const storeRef = useRef(
    new MapWidgetNewsStore(map.mapProperties, mouseController),
  );

  const store = storeRef.current;

  return (
    <NewsContext.Provider value={store}>
      <NewsActivator status={status}>
        <NewsCardModal
          card={store.card}
          categoriesLoader={store.categoriesLoader}
        />
      </NewsActivator>

      {children}
    </NewsContext.Provider>
  );
};
